import React from 'react'
import css from './WelcomePrivacyPolicy.module.css'

const WelcomePrivacyPolicy = () => {
	return (
		<section className={css.welcomeSection}>
			<div className={css.welcomeContainer}>
				<p className={css.welcomeText}>POLITYKA PRYWATNOŚĆI</p>
			</div>
		</section>
	)
}

export default WelcomePrivacyPolicy
